module.exports = __webpack_public_path__ + "img/hok1.567bd791.png";